import { useTranslation } from 'react-i18next';
import { TwitterAnalyticsPostsByDatePayload } from '@anytag/graphql';
import { PostModal } from '../shared';

export interface TwitterPostInDateDetailsModalProps {
  paramKey?: string;
  data: TwitterAnalyticsPostsByDatePayload | null;
}

export const TwitterPostInDateDetailsModal = ({ data, paramKey }: TwitterPostInDateDetailsModalProps) => {
  const { t } = useTranslation();

  return (
    <PostModal posts={data?.posts || []} paramKey={paramKey}>
      {({ selectedPost }) => (
        <>
          <PostModal.Title>{t('Post Detail')}</PostModal.Title>
          <PostModal.DetailsTemplate
            data={{
              socialMedia: 'TWITTER',
              caption: selectedPost.content,
              postUrl: selectedPost.postUrl,
              postDate: selectedPost.postDate,
              images: selectedPost.images || [],
              info: {
                avatar: data?.avatar,
                name: data?.username,
                followers: data?.followers
              },
              comments:
                selectedPost.comments.map((comment) => ({ content: comment.content, username: comment.posterName })) ||
                [],
              statistics: {
                likes: selectedPost.like,
                views: selectedPost.view,
                replies: selectedPost.reply,
                retweets: selectedPost.retweet,
                quoteTweet: selectedPost.quoteTweet,
                impressions: selectedPost.impression,
                engagement: selectedPost.engagement
              }
            }}
          />
        </>
      )}
    </PostModal>
  );
};
